import * as React from "react";
import Grid from "@mui/material/Grid";
import {
  Radio,
  RadioGroup,
  TextField,
  FormControl,
  FormControlLabel,
  FormLabel,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

import {
  AppraisalReviewServiceURL,
  InvestmentServiceURL,
  TaskmgmtServiceURL,
} from "../../../config/config";
import { getApiCall, postApiCall } from "../../../services/apiHelper";
// import { constants } from "buffer";
import { ServiceName } from "../../../constants";
import { useEffect, useState, ChangeEvent } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { CurrentUser } from "../../../redux/slices/currentUserSlice";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useForm, Controller, FieldValues } from "react-hook-form";
import {
  InvestmentNames
} from "../../../redux/slices/selectedInvestmentForAppraisalslice";
import { UserContext } from "../../../redux/slices/userContextSlice";
import { InvestmentAppraisalValuesForm } from "./InvestmentAppraisalValuesForm";
import { InvestmentAssetValuesTableForm } from "./InvestmentAssetValuesTableForm";
import { getInvestmentMaster } from "../../../redux/slices/AddUpdateInvestmentMasterSlice";
import { getAllApplicationUser } from "../../../redux/slices/GetAllApplicationUserSlice";
import { getAllFunds } from "../../../redux/slices/GetAllFundsForInvestmentMasterSlice";
import {
  ApplicationUser,
  Asset,
  Funds,
  InvestmentMasterAppraisalValue,
  InvestmentMasterModel,
} from "../../../all_Interfaces";
import { wait } from "@testing-library/user-event/dist/utils";
import { ToastMessage } from "../../util/ToastMessage";
import { UserDetails } from "../../../layout/UserDetails";
import dayjs from "dayjs";
import { updateInvestmentAppraisal } from "../../../redux/slices/UpdateInvestmentMasterAppraisalValueSlice";
import { updateInvestmentAsset } from "../../../redux/slices/InvestmentMasterAssetSlice";
import { AlertDialog } from "components/util/Dialog";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

type Fund = {
  label: string;
  fundId: string;
  fundName: string;
};

interface Investment {
  fund: Fund;
  investmentId: string;
  investmentName: string;
  investmentType: string;
  assetManager: ApplicationUser;
  assetManagerHead: ApplicationUser;
  propertyType: string;
  sectorHead: ApplicationUser;
  portfolioManager: ApplicationUser;
  asstPortfolioManager: ApplicationUser;
  city: string;
  state: string;
  country: string;
  hasDebtLiability: string;
  investmentStatus: string;
  fgInvestmentAppraisalValues: InvestmentMasterAppraisalValue;
  assets: Asset[];
}

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: "0.9rem" }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(90deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

export const InvetmentsFormNew = () => {
  const navigate = useNavigate();
  const params = useParams();
  const page = params.page;
  const userId = params.userRoleId;
  const dispatch = useAppDispatch();
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  // const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const assets: Asset[] = useAppSelector(
    (state) => state.UpdateInvestmentAsset.data
  );
  const investmentAppraisalValue: InvestmentMasterAppraisalValue =
    useAppSelector((state) => state.UpdateInvestmentMasterAppraisal.data);
  const [fundList, setFundList] = useState<
    { label: string; fundId: string; fundName: string }[]
  >([]);
  const [userList, setUserList] = useState<
    ({ label: string; user: ApplicationUser } | undefined)[]
  >([]);
  // const handleChange =
  //   (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
  //     setExpanded(newExpanded ? panel : false);
  //   };
  const [validators, setValidators] = useState<
    { label: string; isEmpty: boolean; valid: boolean }[]
  >([
    { label: "Fund", isEmpty: true, valid: false },
    { label: "InvestmentID", isEmpty: true, valid: false },
    { label: "InvestmentName", isEmpty: true, valid: false },
    { label: "InvestmentType", isEmpty: true, valid: false },
    { label: "PropertyType", isEmpty: true, valid: false },
    { label: "AssetManager", isEmpty: true, valid: false },
    { label: "InvestmentStatus", isEmpty: true, valid: false },
    // { label: "Assets", isEmpty: true,valid:false },
  ]);
  const [loading, setLoading] = useState<boolean>(false);
  const currentUserData: CurrentUser = useAppSelector(
    (state) => state.currentUser.data
  );
  const userContext: UserContext = useAppSelector(
    (state) => state.UserContext.data
  );
  const userLoad = useAppSelector(
    (state) => state.GetAllApplicationUsers.loading
  );
  const fundLoad = useAppSelector(
    (state) => state.GetAllFundsForInvestment.loading
  );
  const allApplicationUser: ApplicationUser[] = useAppSelector(
    (state) => state.GetAllApplicationUsers.data
  );
  const allFunds: Funds[] = useAppSelector(
    (state) => state.GetAllFundsForInvestment.data
  );
  const [investmentType, setInvestmentType] = useState<string>();
  const [isSuccess, setIsSuccess] = useState<{
    isSuccess: boolean;
    message: string;
  }>({ isSuccess: false, message: "" });
  const [isError, setIsError] = useState<{ isError: boolean; message: string }>(
    { isError: false, message: "" }
  );

  const [investmentObj, setInvestmentObj] = useState<Investment>({
    fund: {
      label: "",
      fundId: "",
      fundName: "",
    },
    investmentId: "",
    investmentName: "",
    investmentType: "",
    assetManager: {
      firstName: "",
      lastName: "",
      email: "",
    },
    assetManagerHead: {
      firstName: "",
      lastName: "",
      email: "",
    },
    asstPortfolioManager: {
      firstName: "",
      lastName: "",
      email: "",
    },
    propertyType: "",
    sectorHead: {
      firstName: "",
      lastName: "",
      email: "",
    },
    portfolioManager: {
      firstName: "",
      lastName: "",
      email: "",
    },
    city: "",
    state: "",
    country: "",
    hasDebtLiability: "No",
    investmentStatus: "",
    fgInvestmentAppraisalValues: {
      lastAppraisedValue: 0,
      lastAnnualAppraisedValue: 0,
      nextAppraisalDate: "",
      appraisalStatus: "",
      lastAppraisalDate: "",
      lastAnnualAppraisalDate: "",
      lastAppraisalType: "",
      lastDLAppraisedValue: 0,
      lastDLAnnualAppraisedValue: 0,
      lastDLAppraisalDate: "",
      lastDLAnnualAppraisalDate: "",
    },
    assets: [],
  });

  console.log("Assets from asset table >>> ", assets);
  console.log("appraisal values >>>> ", investmentAppraisalValue);

  useEffect(() => {
    dispatch(updateInvestmentAppraisal({} as InvestmentMasterAppraisalValue));
    dispatch(updateInvestmentAsset([] as Asset[]));
    dispatch(getAllApplicationUser());
    dispatch(getAllFunds());
  }, []);

  // useEffect(() => {
  //   if(Object.keys(userContext).length === 0){

  //   }
  // }, []);

  useEffect(() => {
    setInvestmentObj({
      ...investmentObj,
      fgInvestmentAppraisalValues: investmentAppraisalValue,
    });
  }, [investmentAppraisalValue]);

  useEffect(() => {
    setInvestmentObj({ ...investmentObj, assets: assets });
  }, [assets]);
  useEffect(() => {
    if (Array.isArray(allFunds) && Array.isArray(allApplicationUser)) {
      var USFunds: Funds[] = allFunds.filter((f) => f.region === "US");
      setFundList(
        USFunds.map((fund: Funds) => {
          return {
            label: fund.fundID + ": " + fund.fundName,
            fundId: fund.fundID,
            fundName: fund.fundName,
          };
        })
      );

      var userArr: { label: string; user: ApplicationUser }[] = [];
      userArr = allApplicationUser.map((user: ApplicationUser, index: any) => {
        return {
          label: user.firstName + " " + user.lastName,
          user: user,
        };
      });
      const uniqueOptions = Array.from(
        new Set(userArr.map((a) => a.label))
      ).map((label) => {
        return userArr.find((a) => a.label === label);
      });
      setUserList(uniqueOptions);
    }
  }, [allApplicationUser, allFunds]);
  const investmentTypeList = ["Equity", "Debt Asset", "Mortgage"];
  const investmentStatusList = [
    "New",
    "Pending Acquisition",
    "Active",
    "Dead Deal",
    "Retired/Sold",
    "Sold-Inactive"
  ];
  const { control, handleSubmit } = useForm({});

  const handleInvestmentStatusChange = (value: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "InvestmentStatus"
          ? { ...obj, valid: value != "", isEmpty: value != "" ? false : true }
          : { ...obj }
      )
    );
    setInvestmentObj({ ...investmentObj, investmentStatus: value });
  };

  const handleInvestmentTypeChange = (type: any) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "InvestmentType"
          ? {
            ...obj,
            valid: type != null,
            isEmpty: type != null ? false : true,
          }
          : { ...obj }
      )
    );
    if (type != null) {
      setInvestmentObj({ ...investmentObj, investmentType: type });
    }
    // setInvestmentType(type);
  };
  const handleHasDebtLiabilityChange = (
    event: ChangeEvent<HTMLInputElement>,
    value: string
  ): void => {
    setInvestmentObj({ ...investmentObj, hasDebtLiability: value });
  };
  const handleFundChange = (value: any) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "Fund"
          ? {
            ...obj,
            isEmpty: value != null ? false : true,
            valid: value != null,
          }
          : { ...obj }
      )
    );
    if (value != null) {
      setInvestmentObj({
        ...investmentObj,
        fund: {
          label: value.label,
          fundId: value.fundId,
          fundName: value.fundName,
        },
      });
    } else {
      setInvestmentObj({
        ...investmentObj,
        fund: { label: "", fundId: "", fundName: "" },
      });
    }
  };

  const handleInvestmentIdChange = (id: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "InvestmentID"
          ? { ...obj, isEmpty: id != "" ? false : true, valid: id != "" }
          : { ...obj }
      )
    );
    setInvestmentObj({ ...investmentObj, investmentId: id });
  };
  const handleInvestmentNameChange = (name: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "InvestmentName"
          ? { ...obj, isEmpty: name != "" ? false : true, valid: name != "" }
          : { ...obj }
      )
    );
    setInvestmentObj({ ...investmentObj, investmentName: name });
  };

  const handlePropertyTypeChange = (propType: string) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "PropertyType"
          ? {
            ...obj,
            isEmpty: propType != "" ? false : true,
            valid: propType != "",
          }
          : { ...obj }
      )
    );
    setInvestmentObj({ ...investmentObj, propertyType: propType });
  };
  const handleAssetManagerChange = (value: any) => {
    setValidators(
      validators.map((obj) =>
        obj.label === "AssetManager"
          ? {
            ...obj,
            isEmpty: value != null ? false : true,
            valid: value != null,
          }
          : { ...obj }
      )
    );
    if (value != null) {
      setInvestmentObj({
        ...investmentObj,
        assetManager: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestmentObj({
        ...investmentObj,
        assetManager: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };

  const handleAssetPortfolioManagerChange = (value: any) => {
    if (value != null) {
      setInvestmentObj({
        ...investmentObj,
        asstPortfolioManager: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestmentObj({
        ...investmentObj,
        asstPortfolioManager: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  }
  const handleAssetManagerHeadChange = (value: any) => {
    if (value != null) {
      setInvestmentObj({
        ...investmentObj,
        assetManagerHead: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestmentObj({
        ...investmentObj,
        assetManagerHead: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };
  const handleSectorHeadChange = (value: any) => {
    if (value != null) {
      setInvestmentObj({
        ...investmentObj,
        sectorHead: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestmentObj({
        ...investmentObj,
        sectorHead: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };
  const handlePortfilioManagerChange = (value: any) => {
    if (value != null) {
      setInvestmentObj({
        ...investmentObj,
        portfolioManager: {
          firstName: value.user.firstName,
          lastName: value.user.lastName,
          email: value.user.email,
        },
      });
    } else {
      setInvestmentObj({
        ...investmentObj,
        portfolioManager: {
          firstName: "",
          lastName: "",
          email: "",
        },
      });
    }
  };
  const handleCityChange = (city: string) => {
    setInvestmentObj({ ...investmentObj, city: city });
  };
  const handleStateChange = (state: string) => {
    setInvestmentObj({ ...investmentObj, state: state });
  };
  const handleCountryChange = (country: string) => {
    setInvestmentObj({ ...investmentObj, country: country });
  };

  const submitInvestment = async () => {
    console.log(validators);

    var v = validators.filter((e) => e.valid != true);
    var e = validators.filter((e) => e.isEmpty != false);

    // if(v.length === 1 && v[0].label === "Assets"){
    //   validationFlag = investmentObj.assets.length === undefined;
    // }

    // if(investmentObj.assets.length === undefined || investmentObj.assets.length === 0){
    //   v.splice(v.findIndex((d) => d.label === "Assets"),1);
    //   e.splice(e.findIndex((d) => d.label === "Assets"),1)
    // }

    var invalidAssets: Asset[] = Array.isArray(investmentObj.assets)
      ? investmentObj.assets.filter(
        (asset) => asset.id === "" || asset.name === "" || asset.status === ""
      )
      : [];

    console.log(v, e);

    setIsSubmit(true);
    console.log(currentUserData);
    var currentDate = dayjs();
    var currDate = currentDate.format("MM-DD-YYYY HH:mm:ss");
    var currUserEmail =
      currentUserData.email != undefined ? currentUserData.email : "";

    if (v.length === 0 && e.length === 0 && invalidAssets.length === 0) {
      var assetList: Asset[] = investmentObj.assets.map((a: Asset) => {
        return {
          ...a,
          investmentId: investmentObj.investmentId,
          createdBy:
            currentUserData.name != undefined ? currentUserData.name : "",
          lastModifiedBy:
            currentUserData.name != undefined ? currentUserData.name : "",
          created: currDate,
          lastModified: currDate,
        };
      });
      console.log(assetList);

      const investmentDB: InvestmentMasterModel = {
        id: investmentObj.investmentId,
        investmentId: investmentObj.investmentId,
        name: investmentObj.investmentName,
        fundId: investmentObj.fund.fundId,
        fund: investmentObj.fund.fundName,
        assetManager: investmentObj.assetManager,
        assetManagerName: "",
        investmentType: investmentObj.investmentType,
        propertyType: investmentObj.propertyType,
        city: investmentObj.city,
        state: investmentObj.state,
        country: investmentObj.country,
        hasDebtLiability:
          investmentObj.hasDebtLiability === "Yes" ? true : false,
        lastAnnualAppraisedValue: 0,
        asstPortfolioManager: investmentObj.asstPortfolioManager,
        status: investmentObj.investmentStatus,
        portfolioManager: investmentObj.portfolioManager,
        assetManagerHead: investmentObj.assetManagerHead,
        sectorHead: investmentObj.sectorHead,
        xmin: 0,
        createdBy: currUserEmail,
        fgInvestmentAppraisalValues: investmentObj.fgInvestmentAppraisalValues,
        assets: assetList,
        created: currDate,
        lastModifiedBy: currUserEmail,
        lastModified: currDate,
        lastSyncedOn: currDate,
      };
      console.log(investmentDB);
      try {
        setLoading(true);
        await postApiCall(
          InvestmentServiceURL + "/investments/add",
          investmentDB,
          ServiceName.INVESTMENTSERVICE
        )
          .then((res: any) => {
            setIsSuccess({
              isSuccess: true,
              message: "Investment is submitted",
            });
            wait(3000).then(() => {
              navigate("/investmentmaster/list");
            });
          })
          .catch((error: any) => {
            console.log(error);
            setIsError({
              isError: true,
              message: error.response.data.responseException.exceptionMessage,
            });
          });
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(updateInvestmentAppraisal({} as InvestmentMasterAppraisalValue));
        dispatch(updateInvestmentAsset([] as Asset[]));
        setLoading(false);
      }
    } else {
      setIsError({ isError: true, message: "Clear the validation errors" });
      wait(3000).then(() => {
        setIsError({ isError: false, message: "" });
      });
    }
  };

  
  return (
    <div className="form-wrap">
      
      <Box sx={{ width: "100%", typography: "body1" }}>
      
        {(userLoad || fundLoad) && (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        )}

        {loading && (
          <div className="overlaySpinner">
            <CircularProgress />
          </div>
        )}

        {isSuccess.isSuccess && (
          <ToastMessage message={isSuccess.message} severity="success" />
        )}
        {isError.isError && (
          <ToastMessage message={isError.message} severity="error" />
        )}
        <h3 className="heading">Investment Values :</h3>
        <Grid container spacing={3}>
          <Grid item xs={6} sm={6}>
            <Controller
              name="fundName"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="fund-id"
                  options={fundList}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleFundChange(value);
                  }}
                  // sx={{ width: 400 }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fund"
                      size="small"
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}    
                      error={isSubmit && investmentObj.fund.label === ""}
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="InvestmentID"
              control={control}
              render={({ field }) => (
                <TextField
                  required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  onChange={(e) => handleInvestmentIdChange(e.target.value)}
                  label="Investment ID"
                  defaultValue=""
                  variant="outlined"
                  size="small"
                  error={isSubmit && investmentObj.investmentId === ""}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="InvestmentName"
              control={control}
              render={({ field }) => (
                <TextField
                  required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  onChange={(e) => handleInvestmentNameChange(e.target.value)}
                  label="Investment Name"
                  defaultValue=""
                  variant="outlined"
                  size="small"
                  error={isSubmit && investmentObj.investmentName === ""}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="investmentType"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="investmentType-id"
                  options={investmentTypeList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleInvestmentTypeChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Investment Type"
                      size="small"
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                      error={isSubmit && investmentObj.investmentType === ""}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="PropertyType"
              control={control}
              render={({ field }) => (
                <TextField
                  required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                  onChange={(e) => handlePropertyTypeChange(e.target.value)}
                  label="Property Type"
                  variant="outlined"
                  size="small"
                  error={isSubmit && investmentObj.propertyType === ""}
                  fullWidth
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="AssetManager"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="AssetManager-id"
                  options={userList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleAssetManagerChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Asset Manager"
                      size="small"
                      error={
                        isSubmit && investmentObj.assetManager.email === ""
                      }
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="AssetManagerHead"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="AssetManagerHead-id"
                  options={userList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleAssetManagerHeadChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Asset Manager Head"
                      size="small"
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="SectorHead"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="SectorHead-id"
                  options={userList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleSectorHeadChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Sector Head" size="small" />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="Portfolio"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="Portfolio-id"
                  options={userList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handlePortfilioManagerChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Portfolio Manager"
                      size="small"
                    />
                  )}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} sm={6}>
            <Controller
              name="city"
              control={control}
              render={({ field }) => (
                <TextField
                  label="City"
                  onChange={(e) => handleCityChange(e.target.value)}
                  defaultValue=""
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="state"
              control={control}
              render={({ field }) => (
                <TextField
                  label="State"
                  onChange={(e) => handleStateChange(e.target.value)}
                  defaultValue=""
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="Country"
              control={control}
              render={({ field }) => (
                <TextField
                  label="Country"
                  onChange={(e) => handleCountryChange(e.target.value)}
                  defaultValue=""
                  variant="outlined"
                  fullWidth
                  size="small"
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <FormControl
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <FormLabel id="row-radio-buttons-group-label">
                Has Debt Liability <span style={{color:'red'}}>*</span>
              </FormLabel>
              <RadioGroup
                row
                style={{ marginLeft: "25px" }}
                aria-labelledby="row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={investmentObj.hasDebtLiability}
                onChange={handleHasDebtLiabilityChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="InvestmentStatus"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="Investment-status"
                  options={investmentStatusList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleInvestmentStatusChange(value != null ? value : "");
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Investment Status"
                      size="small"
                      error={
                        isSubmit &&
                        (investmentObj.investmentStatus === null ||
                          investmentObj.investmentStatus === "")
                      }
                      required
                      InputLabelProps={{
                        sx:{
                            '& .MuiInputLabel-asterisk' : {
                              color:'red',
                            },
                        },
                      }}
                    />
                  )}
                />
              )}
            />
          </Grid>
          <Grid item xs={6} sm={6}>
            <Controller
              name="AssetPortfolioManager"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  id="AssetPortfolioManager-id"
                  options={userList}
                  // sx={{ width: 400 }}
                  onChange={(event, value) => {
                    field.onChange(value);
                    handleAssetPortfolioManagerChange(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Asset Portfolio Manager"
                      size="small"
                    />
                  )}
                />
              )}
            />
          </Grid>
        </Grid>
      </Box>
      {investmentObj.investmentType != "Mortgage" && (
        <>
          <Divider className="divider-line"></Divider>
          <Box
            sx={{ width: "100%", typography: "body1" }}
            className="accordion-wrap"
          >
            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls="panel1d-content"
                id="panel1d-header"
              >
                <Typography>Appraisal Value</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <InvestmentAppraisalValuesForm
                  isDebtLiability={investmentObj.hasDebtLiability}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion defaultExpanded>
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
              >
                <Typography>Asset Values</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <InvestmentAssetValuesTableForm
                  submit={isSubmit}
                // validators={validators}
                // setValidators={setValidators}
                />
              </AccordionDetails>
            </Accordion>
          </Box>
        </>
      )}
      <Box sx={{ padding: "15px 2px" }}>
        <Grid item xs={12} sm={12}>
          <Button sx={{textTransform:"none"}}
            disabled={isError.isError || isSuccess.isSuccess}
            variant="contained"
            size="medium"
            color="success"
            onClick={submitInvestment}
          >
            Submit
          </Button>
          <Button 
            variant="outlined"
            size="medium"
            color="error"
            sx={{ ml: 2 }}
            onClick={() => navigate("/investmentmaster/list")}
          >
            Cancel
          </Button>
        </Grid>
      </Box>
    </div>
  );
};


